import React from 'react'

export default class IconLogoSiteground extends React.Component {
    render() {
        let color = '#C8C5FE'
        if (this.props.color) color = this.props.color
        let className = 'icons-icon'

        return (
            <svg
                className={className}
                style={this.props.style}
                xmlns='http://www.w3.org/2000/svg'
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
            >
                <rect width='24' height='24' rx='6' fill='white' />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M8.4635 18.7427C5.64727 17.8217 3.63792 15.0856 3.14519 12.2186C1.78565 4.30477 10.2079 -2.83563 18.6194 1.12933C18.719 2.90678 17.8935 5.43614 15.6283 6.19631C26.8717 13.2946 17.259 27.8354 5.47613 23.054C3.32666 21.9578 4.47415 19.9538 6.77244 21.1145C9.339 21.9995 12.674 21.9995 14.7755 20.8392C16.1471 20.1173 17.3214 19.071 18.1961 17.7915C18.5093 17.3157 18.7808 16.8136 19.0075 16.291C19.1857 15.8714 19.7598 14.1415 19.3142 13.9526C19.2026 13.9059 19.1439 14.0382 19.1133 14.1622C18.8246 15.2892 18.272 16.3314 17.5012 17.2029C16.5723 18.2859 15.3748 19.1054 14.029 19.5793C12.3487 20.1915 10.4013 20.2688 7.72358 19.683C7.9005 19.4917 8.25516 18.9593 8.46102 18.7427H8.4635ZM16.2256 1.84031C16.2696 2.09926 16.295 2.36104 16.3017 2.62363C16.3482 3.1993 16.2602 3.77792 16.0445 4.3137C15.8289 4.84948 15.4915 5.32773 15.0591 5.71061C14.8702 5.89993 14.6552 6.09669 14.4163 6.30089C17.5918 8.2751 19.2502 12.5927 17.407 15.6102C14.9194 19.676 9.98963 18.7517 7.29699 15.9678C4.47745 13.0536 4.85113 9.28288 6.87619 6.48814C7.9707 5.04498 9.38414 3.87451 11.006 3.06822C12.6279 2.26193 14.4143 1.84168 16.2256 1.84031Z'
                    fill='#96CB4C'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M6.65547 10.7662C7.2598 4.73112 14.2026 3.53651 16.7828 11.5793C18.8649 19.8465 5.69688 18.0471 6.65547 10.7662ZM12.3185 14.7345C17.8013 14.9345 15.174 9.32729 11.5745 8.08803C8.00675 6.85993 6.02302 14.7341 12.3185 14.7345Z'
                    fill='#333230'
                />
            </svg>
        )
    }
}
